import { useFormAtom } from "../../../utils/form/formAtom/hooks";
import { FormAtom } from "../../../utils/form/formAtom/types";
import {
    extractIntegerPrecision,
    extractNumberMax,
    extractNumberMin,
    extractRequired,
} from "../../../utils/form/formAtom/validation";
import { parseNumberOrNull } from "../../../utils/numeric";
import { NumberInput, NumberInputBaseProps } from "../fields/numberInput";

export interface FANumberInputProps<T> extends NumberInputBaseProps {
    atom: FormAtom<T>;
}

export function FANumberInput<T extends number | null>({
    atom,
    className,
    label,
    disabled,
    placeholder,
    styleVariant,
    step,
    autoFocus,
    addonAfter,
    addonBefore,
    precision,
}: FANumberInputProps<T>) {
    const { value, error, setCacheValue, dispatchValue, schema } =
        useFormAtom(atom);

    return (
        <NumberInput
            value={value}
            onBlur={(e) =>
                void dispatchValue(parseNumberOrNull(e.target.value) as T)
            }
            error={error?.value}
            onChange={(changeValue: number | null) =>
                setCacheValue(changeValue as Awaited<T>)
            }
            min={extractNumberMin(schema)}
            max={extractNumberMax(schema)}
            required={extractRequired(schema)}
            precision={precision ?? extractIntegerPrecision(schema)}
            className={className}
            label={label}
            disabled={disabled}
            placeholder={placeholder}
            styleVariant={styleVariant}
            step={step}
            autoFocus={autoFocus}
            addonBefore={addonBefore}
            addonAfter={addonAfter}
        />
    );
}
